import React, { useState, useEffect } from 'react';

import { verServApi } from "@api/wp/agenda/servicios/serviciosApi"
import { verSedesApi } from "@api/wp/agenda/sedes/sedesApi"
import { verDispApi } from "@api/wp/agenda/disponibilidad/disponibilidadApi"
import { verMedicosApi } from "@api/wp/agenda/medicos/medicosApi"
import { verJornadasApi } from "@api/wp/agenda/jornadas/jornadasApi"
import { verHorasApi } from "@api/wp/agenda/horas/horasApi"

function Agenda() {
  const [busqueda, setBusqueda] = useState('');
  const [resultados, setResultados] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [servicioSeleccionado, setServicioSeleccionado] = useState(null);
  const [pantallaActual, setPantallaActual] = useState('servicios'); // 'servicios' o 'sedes'
  const [sedes, setSedes] = useState([]);
  const [cargandoSedes, setCargandoSedes] = useState(false);
  const [errorSedes, setErrorSedes] = useState('');
  const [disponibilidad, setDisponibilidad] = useState([]);
  const [cargandoDisponibilidad, setCargandoDisponibilidad] = useState(false);
  const [errorDisponibilidad, setErrorDisponibilidad] = useState('');
  const [sedeSeleccionada, setSedeSeleccionada] = useState(null);
  const [modalFechaAbierta, setModalFechaAbierta] = useState(false);
  const [fechaSeleccionada, setFechaSeleccionada] = useState(null);
  const [medicos, setMedicos] = useState([]);
  const [cargandoMedicos, setCargandoMedicos] = useState(false);
  const [errorMedicos, setErrorMedicos] = useState(null);
  const [horas, setHoras] = useState([]);
  const [cargandoHoras, setCargandoHoras] = useState(false);
  const [errorHoras, setErrorHoras] = useState(null);
  const [ciudadSeleccionada, setCiudadSeleccionada] = useState(null);
  // Seleccionados
  const [empresa, setEmpresa] = useState("");
  const [servicio, setServicio] = useState("");
  const [sede, setSede] = useState("");

  // JSON de ciudades
  const ciudades = [
    { "ciudad": "Barranquilla" },
    { "ciudad": "Cartagena" },
    { "ciudad": "Santa Marta" },
    { "ciudad": "Soledad" },
    { "ciudad": "Malambo" }
  ];

  const buscarServicios = async () => {
    if (!busqueda.trim()) {
      setError('Por favor ingrese un término de búsqueda');
      return;
    }
    setCargando(true);
    setError('');
    try {
      const request = {
        departamento: 'atlantico',
        nombre_servicio: busqueda
      }
      console.log(request)
      const response = await verServApi(request)
      console.log('RESPO g ', response.data)
      setResultados(response.data || []);
    } catch (err) {
      setError('Error al consultar los servicios ' + err.message);
      setResultados([]);
    } finally {
      setCargando(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      buscarServicios();
    }
  };

  const buscarSedes = async (servicio) => {
    console.log('Servicio ', servicio)
    setServicio(servicio.oid_servicio)
    setEmpresa(servicio.nombre_empresa)

    setServicioSeleccionado(servicio);
    setPantallaActual('sedes');
    setCargandoSedes(true);
    setErrorSedes('');
    setSedes([]);

    try {
      const request = {
        empresa: "salud-social"
      };
      console.log('Consultando sedes con:', request);
      const response = await verSedesApi(request);
      console.log('Respuesta sedes:', response.data);
      setSedes(response.data || []);
    } catch (err) {
      setErrorSedes('Error al consultar las sedes: ' + err.message);
      setSedes([]);
    } finally {
      setCargandoSedes(false);
    }
  };

  const volverAServicios = () => {
    setPantallaActual('servicios');
    setServicioSeleccionado(null);
    setSedes([]);
    setErrorSedes('');
    setDisponibilidad([]);
    setErrorDisponibilidad('');
    setSedeSeleccionada(null);
    setModalFechaAbierta(false);
    setFechaSeleccionada(null);
  };

  const seleccionarFecha = async (fecha) => {
    setFechaSeleccionada(fecha);
    setModalFechaAbierta(true);
    setCargandoMedicos(true);
    setErrorMedicos(null);
    setMedicos([]);

    try {
      const response = await verMedicosApi({
        empresa: "promocosta",
        oid_sede: "3",
        oid_especialidad: 69,
        fecha: fecha
      });

      if (response && response.data) {
        // Para cada médico, consultar sus jornadas
        const medicosConJornadas = await Promise.all(
          response.data.map(async (medico) => {
            try {
              const req = {
                "empresa": "promocosta",
                "oid_medico": 38,
                "fecha": "2025-08-30"
              }
              const jornadaResponse = await verJornadasApi(req);
                console.log('jorada ', jornadaResponse)                            
              return {
                  ...medico,
                  jornada: jornadaResponse?.data || []
                };
              } catch (error) {
                console.error(`Error al consultar jornada para médico ${medico.oid_medico}:`, error);
                return {
                  ...medico,
                  jornada: []
                };
              }
            })
        );

        setMedicos(medicosConJornadas);
      } else {
        setMedicos([]);
      }
    } catch (error) {
      console.error('Error al consultar médicos:', error);
      setErrorMedicos('Error al cargar los médicos');
    } finally {
      setCargandoMedicos(false);
    }
  };

  const cerrarModalFecha = () => {
    setModalFechaAbierta(false);
    setFechaSeleccionada(null);
    setMedicos([]);
    setErrorMedicos(null);
    setCargandoMedicos(false);
    setHoras([]);
    setErrorHoras(null);
    setCargandoHoras(false);
  };

  const traerHoras = async (oidTurno, oidMedico) => {
    setCargandoHoras(true);
    setErrorHoras(null);
    setHoras([]);
    
    try {
      const response = await verHorasApi({
        empresa: "promocosta",
        oid_medico: oidMedico,
        fecha: fechaSeleccionada,
        oid_turno: oidTurno
      });
      
      if (response && response.data) {
        setHoras(response.data);
      } else {
        setHoras([]);
      }
    } catch (error) {
      console.error('Error al consultar horas:', error);
      setErrorHoras('Error al cargar las horas');
    } finally {
      setCargandoHoras(false);
    }
  };

  const verDisponibilidad = async (sede) => {
    setSedeSeleccionada(sede);
    setSede(sede.oid)
    setCargandoDisponibilidad(true);
    setErrorDisponibilidad('');
    setDisponibilidad([]);

    try {
      const requ = {
        "empresa": empresa,
        "oid_sede": sede.oid,
        "oid_especialidad": servicio
      }
      const response2 = await verDispApi(requ);
      const response = {
        "requestId": "298bb904-cd2c-4d84-8b80-30afabc764d6",
        "code": 200,
        "message": "Fechas encontradas exitosamente en Dinamica gerencial",
        "data": [
          "2025-08-21",
          "2025-08-23",
          "2025-08-28",
          "2025-08-30"
        ]
      }
      console.log('res dos ', response)
      if (response && response.data) {
        setDisponibilidad(response.data);
      } else {
        setDisponibilidad([]);
      }
    } catch (error) {
      console.error('Error al consultar disponibilidad:', error);
      setErrorDisponibilidad('Error al cargar la disponibilidad');
    } finally {
      setCargandoDisponibilidad(false);
    }
  };

  useEffect(() => {

  }, []);

  return (
    <div style={{ padding: '20px' }}>
      {/* Pantalla de Servicios */}
      {pantallaActual === 'servicios' && (
        <>
          {/* Selector de Ciudad */}
          <div style={{ marginBottom: '20px' }}>
            <h3 style={{ marginBottom: '10px', color: '#333' }}>Seleccionar Ciudad:</h3>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
              {ciudades.map((ciudad, index) => (
                <div
                  key={index}
                  onClick={() => setCiudadSeleccionada(ciudad.ciudad)}
                  style={{
                    padding: '8px 12px',
                    backgroundColor: ciudadSeleccionada === ciudad.ciudad ? '#28a745' : '#007bff',
                    color: 'white',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    transition: 'all 0.2s ease',
                    border: 'none',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                  }}
                  onMouseEnter={(e) => {
                    if (ciudadSeleccionada !== ciudad.ciudad) {
                      e.target.style.backgroundColor = '#0056b3';
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (ciudadSeleccionada !== ciudad.ciudad) {
                      e.target.style.backgroundColor = '#007bff';
                    }
                  }}
                >
                  {ciudad.ciudad}
                </div>
              ))}
            </div>
            {ciudadSeleccionada && (
              <p style={{ marginTop: '10px', color: '#28a745', fontWeight: 'bold' }}>
                Ciudad seleccionada: {ciudadSeleccionada}
              </p>
            )}
          </div>

          <h2>Agenda - Consultar Servicios</h2>

          <div style={{ marginBottom: '20px' }}>
            <input
              type="text"
              placeholder="Buscar servicio (ej: odontologia)"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
              onKeyPress={handleKeyPress}
              style={{
                padding: '10px',
                fontSize: '16px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                width: '300px',
                marginRight: '10px'
              }}
            />
            <button
              onClick={buscarServicios}
              disabled={cargando}
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: cargando ? 'not-allowed' : 'pointer',
                opacity: cargando ? 0.6 : 1
              }}
            >
              {cargando ? 'Buscando...' : 'Buscar'}
            </button>
          </div>

          {error && (
            <div style={{
              color: 'red',
              backgroundColor: '#ffebee',
              padding: '10px',
              borderRadius: '4px',
              marginBottom: '20px'
            }}>
              {error}
            </div>
          )}

          {resultados.length > 0 && (
            <div>
              <h3>Resultados ({resultados.length}):</h3>
              <div style={{
                maxHeight: '500px',
                overflowY: 'auto',
                border: '1px solid #ddd',
                borderRadius: '4px'
              }}>
                <table style={{
                  width: '100%',
                  borderCollapse: 'collapse',
                  fontSize: '14px'
                }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f5f5f5', position: 'sticky', top: 0 }}>
                      <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Código CUP</th>
                      <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Nombre Plan</th>
                      <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Nombre Servicio</th>
                      <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Valor Servicio</th>
                      <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Nombre Empresa</th>
                      <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Código Manual</th>
                      <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'center' }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resultados.map((servicio, index) => (
                      <tr key={index} style={{
                        backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white',
                        cursor: 'pointer'
                      }}>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                          {servicio.cod_cup || 'N/A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                          {servicio.nombre_plan || 'N/A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                          {servicio.nombre_servicio || 'N/A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                          {servicio.valor_servicio ? `$${Number(servicio.valor_servicio).toLocaleString()}` : 'N/A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                          {servicio.nombre_empresa || 'N/A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                          {servicio.codigo_manual || 'N/A'}
                        </td>
                        <td style={{ padding: '10px', border: '1px solid #ddd', textAlign: 'center' }}>
                          <button
                            onClick={() => buscarSedes(servicio)}
                            style={{
                              padding: '6px 12px',
                              fontSize: '12px',
                              backgroundColor: '#28a745',
                              color: 'white',
                              border: 'none',
                              borderRadius: '4px',
                              cursor: 'pointer'
                            }}
                            onMouseOver={(e) => e.target.style.backgroundColor = '#218838'}
                            onMouseOut={(e) => e.target.style.backgroundColor = '#28a745'}
                          >
                            Buscar Sedes
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {!cargando && resultados.length === 0 && busqueda && !error && (
            <div style={{
              color: '#666',
              fontStyle: 'italic',
              textAlign: 'center',
              padding: '20px'
            }}>
              No se encontraron resultados para "{busqueda}"
            </div>
          )}
        </>
      )}

      {/* Pantalla de Sedes */}
      {pantallaActual === 'sedes' && (
        <>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            marginBottom: '20px',
            borderBottom: '1px solid #eee',
            paddingBottom: '10px'
          }}>
            <button
              onClick={volverAServicios}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                backgroundColor: '#6c757d',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                marginRight: '15px'
              }}
              onMouseOver={(e) => e.target.style.backgroundColor = '#5a6268'}
              onMouseOut={(e) => e.target.style.backgroundColor = '#6c757d'}
            >
              ← Anterior
            </button>
            <div>
              <h2 style={{ margin: 0 }}>Sedes Disponibles</h2>
              {servicioSeleccionado && (
                <span style={{ fontSize: '14px', color: '#666' }}>
                  Servicio: {servicioSeleccionado.nombre_servicio}
                </span>
              )}
            </div>
          </div>

          {cargandoSedes && (
            <div style={{
              textAlign: 'center',
              padding: '40px',
              color: '#666',
              fontSize: '16px'
            }}>
              Cargando sedes...
            </div>
          )}

          {errorSedes && (
            <div style={{
              color: 'red',
              backgroundColor: '#ffebee',
              padding: '15px',
              borderRadius: '4px',
              marginBottom: '20px'
            }}>
              {errorSedes}
            </div>
          )}

          <div style={{ display: 'flex', gap: '20px' }}>
            {/* Tabla de Sedes */}
            <div style={{ flex: '0 0 400px' }}>
              {!cargandoSedes && sedes.length > 0 && (
                <div style={{
                  maxHeight: '500px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}>
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: '14px'
                  }}>
                    <thead>
                       <tr style={{ backgroundColor: '#f5f5f5', position: 'sticky', top: 0 }}>
                         <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Médico</th>
                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Jornada</th>
                       </tr>
                     </thead>
                    <tbody>
                      {sedes.map((sede, index) => (
                        <tr key={index} style={{
                          backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'
                        }}>
                          <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                            {sede.nombre_sede || 'N/A'}
                          </td>
                          <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                            <button
                              onClick={() => verDisponibilidad(sede)}
                              style={{
                                padding: '6px 12px',
                                backgroundColor: '#007bff',
                                color: 'white',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Ver Disponibilidad
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Resultados de Disponibilidad */}
            <div style={{ flex: '1' }}>
              {sedeSeleccionada && (
                <div>
                  <h3>Disponibilidad - {sedeSeleccionada.nombre_sede}</h3>

                  {cargandoDisponibilidad && (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <p>Cargando disponibilidad...</p>
                    </div>
                  )}

                  {errorDisponibilidad && (
                    <div style={{
                      backgroundColor: '#f8d7da',
                      color: '#721c24',
                      padding: '10px',
                      borderRadius: '4px',
                      marginBottom: '20px'
                    }}>
                      {errorDisponibilidad}
                    </div>
                  )}

                  {!cargandoDisponibilidad && !errorDisponibilidad && disponibilidad.length > 0 && (
                    <div style={{
                      backgroundColor: 'white',
                      padding: '15px',
                      borderRadius: '4px',
                      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                      maxHeight: '500px',
                      overflowY: 'auto'
                    }}>
                      <h4>Fechas Disponibles:</h4>
                      <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
                        gap: '10px',
                        marginTop: '10px'
                      }}>
                        {disponibilidad.map((fecha, index) => (
                          <div
                            key={index}
                            onClick={() => seleccionarFecha(fecha)}
                            style={{
                              padding: '10px',
                              backgroundColor: '#e3f2fd',
                              border: '2px solid #2196f3',
                              borderRadius: '8px',
                              textAlign: 'center',
                              cursor: 'pointer',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              color: '#1976d2',
                              transition: 'all 0.2s ease',
                              ':hover': {
                                backgroundColor: '#bbdefb'
                              }
                            }}
                            onMouseEnter={(e) => {
                              e.target.style.backgroundColor = '#bbdefb';
                              e.target.style.transform = 'scale(1.05)';
                            }}
                            onMouseLeave={(e) => {
                              e.target.style.backgroundColor = '#e3f2fd';
                              e.target.style.transform = 'scale(1)';
                            }}
                          >
                            {new Date(fecha).toLocaleDateString('es-ES', {
                              day: '2-digit',
                              month: 'short',
                              year: 'numeric'
                            })}
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {!cargandoDisponibilidad && !errorDisponibilidad && disponibilidad.length === 0 && sedeSeleccionada && (
                    <div style={{ textAlign: 'center', padding: '20px' }}>
                      <p>No se encontró disponibilidad para esta sede.</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {!cargandoSedes && sedes.length === 0 && !errorSedes && (
            <div style={{
              color: '#666',
              fontStyle: 'italic',
              textAlign: 'center',
              padding: '40px',
              fontSize: '16px'
            }}>
              No se encontraron sedes disponibles
            </div>
          )}
        </>
      )}

      {/* Modal para mostrar fecha seleccionada */}
      {modalFechaAbierta && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            maxWidth: '600px',
            width: '90%',
            textAlign: 'center',
            maxHeight: '80vh',
            overflowY: 'auto'
          }}>
            <h3 style={{ marginTop: 0, color: '#333' }}>Fecha Seleccionada</h3>
            <div style={{
              padding: '20px',
              backgroundColor: '#f8f9fa',
              borderRadius: '4px',
              margin: '20px 0',
              fontSize: '18px',
              fontWeight: 'bold',
              color: '#1976d2'
            }}>
              {fechaSeleccionada && new Date(fechaSeleccionada).toLocaleDateString('es-ES', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </div>

            {/* Sección de médicos */}
            <div style={{ marginTop: '20px', textAlign: 'left' }}>
              <h4 style={{ color: '#333', marginBottom: '15px' }}>Médicos Disponibles:</h4>

              {cargandoMedicos && (
                <div style={{ textAlign: 'center', padding: '20px' }}>
                  <p>Cargando médicos...</p>
                </div>
              )}

              {errorMedicos && (
                <div style={{
                  backgroundColor: '#f8d7da',
                  color: '#721c24',
                  padding: '10px',
                  borderRadius: '4px',
                  marginBottom: '20px',
                  textAlign: 'center'
                }}>
                  {errorMedicos}
                </div>
              )}

              {!cargandoMedicos && !errorMedicos && medicos.length > 0 && (
                <div style={{
                  maxHeight: '300px',
                  overflowY: 'auto',
                  border: '1px solid #ddd',
                  borderRadius: '4px'
                }}>
                  <table style={{
                    width: '100%',
                    borderCollapse: 'collapse',
                    fontSize: '14px'
                  }}>
                    <thead>
                      <tr style={{ backgroundColor: '#f5f5f5', position: 'sticky', top: 0 }}>
                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Médico</th>
                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Jornada</th>
                        <th style={{ padding: '12px', border: '1px solid #ddd', textAlign: 'left' }}>Horas</th>
                      </tr>
                    </thead>
                    <tbody>
                      {medicos.map((medico, index) => (
                        <tr key={index} style={{
                          backgroundColor: index % 2 === 0 ? '#f9f9f9' : 'white'
                        }}>
                          <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                            {medico.nombre_medico || 'N/A'}
                          </td>
                          <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                            <div style={{
                              display: 'flex',
                              flexWrap: 'wrap',
                              gap: '5px'
                            }}>
                              {medico.jornada && medico.jornada.length > 0 ? (
                                medico.jornada.map((horario, horarioIndex) => (
                                  <div
                                    key={horarioIndex}
                                    style={{
                                      backgroundColor: '#e3f2fd',
                                      border: '1px solid #1976d2',
                                      borderRadius: '4px',
                                      padding: '4px 8px',
                                      fontSize: '12px',
                                      color: '#1976d2',
                                      fontWeight: 'bold',
                                      cursor: 'pointer',
                                      transition: 'all 0.2s'
                                    }}
                                    onClick={() => traerHoras(horario.oid_turno || 132926, medico.oid_medico || 38)}
                                    onMouseEnter={(e) => {
                                      e.target.style.backgroundColor = '#bbdefb';
                                    }}
                                    onMouseLeave={(e) => {
                                      e.target.style.backgroundColor = '#e3f2fd';
                                    }}
                                  >
                                    {typeof horario === 'object' ? (horario.franja_horaria || JSON.stringify(horario)) : horario}
                                  </div>
                                ))
                              ) : (
                                <span style={{ color: '#666', fontStyle: 'italic' }}>Sin horarios disponibles</span>
                              )}
                            </div>
                          </td>
                          <td style={{ padding: '10px', border: '1px solid #ddd' }}>
                            {cargandoHoras && (
                              <div style={{ textAlign: 'center', fontSize: '12px', color: '#666' }}>
                                Cargando...
                              </div>
                            )}
                            
                            {errorHoras && (
                              <div style={{ fontSize: '12px', color: '#d32f2f' }}>
                                {errorHoras}
                              </div>
                            )}
                            
                            {!cargandoHoras && !errorHoras && horas.length > 0 && (
                              <div style={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                gap: '3px'
                              }}>
                                {horas.map((hora, horaIndex) => (
                                  <div
                                    key={horaIndex}
                                    style={{
                                      backgroundColor: '#e8f5e8',
                                      border: '1px solid #4caf50',
                                      borderRadius: '3px',
                                      padding: '2px 6px',
                                      fontSize: '11px',
                                      color: '#2e7d32',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    {hora.hora || hora}
                                  </div>
                                ))}
                              </div>
                            )}
                            
                            {!cargandoHoras && !errorHoras && horas.length === 0 && (
                              <span style={{ fontSize: '12px', color: '#999', fontStyle: 'italic' }}>
                                Selecciona una jornada
                              </span>
                            )}
                          </td>                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}

              {!cargandoMedicos && !errorMedicos && medicos.length === 0 && (
                <div style={{ textAlign: 'center', padding: '20px', color: '#666' }}>
                  <p>No se encontraron médicos disponibles para esta fecha.</p>
                </div>
              )}
            </div>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button
                onClick={cerrarModalFecha}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#6c757d',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Cerrar
              </button>
              <button
                onClick={() => {
                  // Aquí puedes agregar lógica adicional para la fecha seleccionada
                  console.log('Fecha seleccionada:', fechaSeleccionada);
                  cerrarModalFecha();
                }}
                style={{
                  padding: '10px 20px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                Confirmar
              </button>
              <br />

            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default Agenda;